import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';

/**
 * Llama al endpoint `GET /avatars/project/{id}/form-data`. Devuelve el shape
 * necesario para poblar el form del Studio (script, character, background,
 * onlyVoice por scene + metadata del proyecto).
 *
 * Se usa en dos flujos:
 *   1. Volver desde el editor (`?editProjectId=xxx`) → popular form para editar.
 *   2. Regenerar desde historial → popular form para crear proyecto nuevo con
 *      esos datos como base.
 */
export const useGetAvatarProjectFormData = () => {
  const { callEndpoint } = useAPIContext();

  const getProjectFormData = React.useCallback(
    async (projectId: string) => {
      try {
        const res = await callEndpoint<AvatarsAPI, 'get-avatar-project-form-data'>(
          'avatars',
          `/project/${projectId}/form-data`,
          'GET'
        );
        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error al obtener form-data del proyecto:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { getProjectFormData };
};
